import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { CATALOGO_NAVIDAD_LLAVE, resolverCatalogoDescarga } from '../../api/catalogoDescargaApi'
import './CatalogoDescargaPage.scss'

export default function CatalogoDescargaPage() {
  const { ruta } = useParams()
  const [estado, setEstado] = useState('cargando')
  const [catalogo, setCatalogo] = useState(null)

  useEffect(() => {
    let activo = true
    resolverCatalogoDescarga(CATALOGO_NAVIDAD_LLAVE).then((resultado) => {
      if (!activo) {
        return
      }
      if (!resultado.segmento || resultado.segmento !== ruta || !resultado.publico) {
        setCatalogo(null)
        setEstado('oculto')
        return
      }
      setCatalogo(resultado.publico)
      setEstado('visible')
    })
    return () => {
      activo = false
    }
  }, [ruta])

  if (estado === 'oculto') {
    return <Navigate to="/" replace />
  }

  if (!catalogo) {
    return null
  }

  return (
    <section className="catalogo-descarga">
      <div className="container py-4">
        {catalogo.bannerUrl && (
          <img className="catalogo-descarga-banner" src={catalogo.bannerUrl} alt="" />
        )}
        <div className="catalogo-descarga-pdf text-center py-4">
          <a className="btn-g py-2 px-4 px-xl-5" href={catalogo.pdfUrl} target="_blank" rel="noopener noreferrer">
            {catalogo.textoBoton}
          </a>
          {catalogo.piezaUrl && (
            <img className="catalogo-descarga-pieza" src={catalogo.piezaUrl} alt={catalogo.textoBoton} />
          )}
        </div>
        {catalogo.qrUrl && (
          <img className="catalogo-descarga-qr" src={catalogo.qrUrl} alt="" />
        )}
      </div>
    </section>
  )
}
